/** Core Defense Matrix (409): general cannot be targeted by strategems or drones. */

export const CORE_DEFENSE_MATRIX_ORDER_ID = 409;

export function playerHasLivingUnitOnBattlefield(gameState, playerId, unitId) {
  const player = gameState?.state?.[playerId];
  if (!player?.playedOrders) {
    return false;
  }
  for (const zone of ['front', 'flank']) {
    for (const unit of player.playedOrders[zone] || []) {
      if (unit && Number(unit.id) === Number(unitId) && (unit.health ?? 0) > 0) {
        return true;
      }
    }
  }
  return false;
}

export function isGeneralProtectedFromStrategemsAndDrones(gameState, generalOwnerPlayerId) {
  if (generalOwnerPlayerId == null || !gameState?.state) {
    return false;
  }
  return playerHasLivingUnitOnBattlefield(
    gameState,
    generalOwnerPlayerId,
    CORE_DEFENSE_MATRIX_ORDER_ID
  );
}

export function resolveGeneralOwnerPlayerId(gameState, casterPlayerId, zone) {
  if (!gameState?.state || casterPlayerId == null) {
    return null;
  }
  const selfId = String(casterPlayerId);
  const opponentId = Object.keys(gameState.state).find((id) => String(id) !== selfId);
  if (zone === 'opponent_general') {
    return opponentId ?? null;
  }
  if (zone === 'player_general') {
    return selfId;
  }
  return null;
}

export function isGeneralZoneBlockedForStrategemOrDrone(gameState, casterPlayerId, zone) {
  const ownerId = resolveGeneralOwnerPlayerId(gameState, casterPlayerId, zone);
  return isGeneralProtectedFromStrategemsAndDrones(gameState, ownerId);
}

export function getCoreDefenseMatrixGeneralBlockReason() {
  return 'General cannot be targeted by strategems or drones while Core Defense Matrix is on the battlefield';
}

export function resolveGeneralOwnerForStrategemTarget(gameState, casterPlayerId, targetUnitId) {
  if (!gameState?.state || casterPlayerId == null) {
    return null;
  }
  const selfId = String(casterPlayerId);
  const opponentId = Object.keys(gameState.state).find((id) => String(id) !== selfId);
  if (targetUnitId === 'friendly') {
    return selfId;
  }
  if (targetUnitId === 'opponent') {
    return opponentId ?? null;
  }
  return null;
}
